import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { LoginPage } from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import { ChangePasswordPage } from '@/pages/ChangePasswordPage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { ResetPasswordPage } from '@/pages/ResetPasswordPage';
import { RevealCredentialPage } from '@/pages/RevealCredentialPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { ProtectedRoute } from '@/routes/ProtectedRoute';
import { MustChangePasswordRoute } from '@/routes/MustChangePasswordRoute';
import { RoleGuard } from '@/routes/RoleGuard';
import { GuestRoute } from '@/routes/GuestRoute';
import { ROUTES } from '@/routes/paths';

function HomeRedirect() {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to={ROUTES.login} replace />;
  }

  if (user.mustChangePassword) {
    return <Navigate to={ROUTES.changePassword} replace />;
  }

  return <Navigate to={ROUTES.dashboard(user.role)} replace />;
}

export function AppRoutes({ onLogin }) {
  return (
    <Routes>
      <Route path={ROUTES.revealCredential} element={<RevealCredentialPage />} />
      <Route element={<GuestRoute />}>
        <Route path={ROUTES.login} element={<LoginPage onLogin={onLogin} />} />
        <Route path={ROUTES.forgotPassword} element={<ForgotPasswordPage />} />
        <Route path={ROUTES.resetPassword} element={<ResetPasswordPage />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route path={ROUTES.changePassword} element={<ChangePasswordPage />} />
        <Route path={ROUTES.profile} element={<ProfilePage />} />

        <Route element={<MustChangePasswordRoute />}>
          <Route element={<RoleGuard />}>
            <Route path="/dashboard/:role/:tab?" element={<DashboardPage />} />
          </Route>
        </Route>
      </Route>

      <Route path={ROUTES.home} element={<HomeRedirect />} />
      <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
    </Routes>
  );
}
